import styled from "styled-components";

export const Table = styled.table`
    border-spacing: 0;
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
    color: black;
    margin: 0 auto 20px;
    line-height: 150%;
`;
